import { render, staticRenderFns } from "./ChapterTab.vue?vue&type=template&id=7ab42238&scoped=true&"
import script from "./ChapterTab.vue?vue&type=script&lang=ts&"
export * from "./ChapterTab.vue?vue&type=script&lang=ts&"
import style0 from "./ChapterTab.vue?vue&type=style&index=0&id=7ab42238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab42238",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/p00353_hh-ballett/client-player/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ab42238')) {
      api.createRecord('7ab42238', component.options)
    } else {
      api.reload('7ab42238', component.options)
    }
    module.hot.accept("./ChapterTab.vue?vue&type=template&id=7ab42238&scoped=true&", function () {
      api.rerender('7ab42238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChapterTab.vue"
export default component.exports